import { Card, CardBody, TabPane } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { post } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function NotificationsTab({ settingsData }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [preferencesData, setPreferencesData] = useState({
    email_notifications: settingsData?.user_settings?.app?.email_notifications ?? true,
    push_notifications: settingsData?.user_settings?.app?.push_notifications ?? true
  });

  const saveNotifications = async () => {
    setSaveLoading(true);
    const data = await post('/settings/preferences/notifications', {
      email_notifications: preferencesData.email_notifications,
      push_notifications: preferencesData.push_notifications
    });
    if(data.success) {
      toast.success(t('preferences.notificationsSaved'));
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setSaveLoading(false);
  }

  return(
    <TabPane tabId="notifications">
      <Card className="mb-3">
        <CardBody>
          <p className="text-muted small fw-semibold text-uppercase mb-3">
            {t('preferences.notificationChannels')}
            <span className="badge bg-secondary ms-2">{t('preferences.userBadge')}</span>
          </p>

          <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
            <div>
              <p className="mb-0 fw-medium">{t('preferences.emailNotifications')}</p>
              <small className="text-muted">{t('preferences.emailNotificationsDesc')}</small>
            </div>
            <div className="form-check form-switch mb-0">
              <input 
                className="form-check-input" 
                type="checkbox" role="switch" 
                checked={Number(preferencesData.email_notifications) === 1} 
                onChange={() => setPreferencesData({ ...preferencesData, email_notifications: !preferencesData.email_notifications })} 
              />
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center py-3 border-bottom">
            <div>
              <p className="mb-0 fw-medium">{t('preferences.inAppNotifications')}</p>
              <small className="text-muted">{t('preferences.inAppNotificationsDesc')}</small>
            </div>
            <div className="form-check form-switch mb-0">
              <input 
                className="form-check-input" 
                type="checkbox" role="switch" 
                checked={Number(preferencesData.push_notifications) === 1} 
                onChange={() => setPreferencesData({ ...preferencesData, push_notifications: !preferencesData.push_notifications })} 
              />
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center py-3">
            <div>
              <p className="mb-0 fw-medium text-muted">{t('preferences.whatsappSms')}</p>
              <small className="text-muted">{t('preferences.whatsappSmsDesc')}</small>
            </div>
            <span className="badge bg-light text-secondary border">{t('common.comingSoon')}</span>
          </div>
        </CardBody>
      </Card>
      <DefaultButton color="primary" size="sm" disabled={saveLoading} loading={saveLoading} onClick={saveNotifications}>
        {t('common.save')}
      </DefaultButton>
    </TabPane>
  );
}

export default NotificationsTab;